import React from "react";

const Header = () => {
  return (
    <div className="header">
      <div className="Header-container">
        <h2>Contact Manager</h2>
      </div>
    </div>
  );
};

export default Header;
